import { Controller } from 'stimulus'

export default class extends Controller {
  resetModalForm(event) {
    // reset the form in the modal in case the opened it before, changed the value
    // and then escaped/closed without saving
    window.document.getElementById(`${event.target.href.split('#')[1]}_form`).reset()
  }
}
